import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { router } from './router'
import { configureBrowserCsrfTokenProvider } from './shared/api/csrf'
import './styles/tokens.css'
import './styles/global.css'

configureBrowserCsrfTokenProvider()

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.mount('#app')
